import { Text as RNText } from 'react-native';

import { cn } from './cn';

export interface SectionMarkerProps {
  /** Two-digit marker, e.g. "01". */
  index: string;
  label: string;
  className?: string;
}

/** "01 — The basics" field-manual marker for legal / onboarding copy. */
export function SectionMarker({ index, label, className }: SectionMarkerProps) {
  return (
    <RNText
      className={cn(
        'font-accent text-xs uppercase tracking-[0.12em] text-muted',
        className,
      )}
    >
      {index} — {label}
    </RNText>
  );
}
